import { Injectable } from '@angular/core';
import { IMediaItem } from '../../_shared/models/media/media-item.model';
import { MediaImage } from '../../_shared/models/media/media-image.model';
import { MediaVideo } from '../../_shared/models/media/media-video.model';

@Injectable({
    providedIn: 'root',
})
export class MediaCollectionService {
    createThumbnails(items: IMediaItem[]): MediaImage[] {
        const thumbnails: MediaImage[] = [];

        items.forEach((x) => {
            let img: MediaImage = x as MediaImage;

            if (x.type === 'video') {
                img = {
                    type: 'image',
                    title: x.title,
                    image: (x as MediaVideo).thumbnail,
                } as MediaImage;
            }

            thumbnails.push(img);
        });

        return thumbnails;
    }
}
